(function (angular, schoolwork12) {

    'use strict';
    angular.module(schoolwork12.app.bulkImport.name).controller(schoolwork12.app.bulkImport.controllers.bulkImport, [
        '$rootScope', '$scope', '$http', '$uibModal', '$location',
         schoolwork12.app.auth.services.authentication,
         schoolwork12.app.common.services.eventNotification,
         schoolwork12.app.bulkImport.services.bulkImportSvc,
        function ($rootScope, $scope, $http, $uibModal, $location, authentication,
                  eventNotification, bulkImportSvc) {

            console.info("In bulk import controller");
            eventNotification.subscribe(schoolwork12.app.auth.events.userLoggedIn,
                function (event, authenticatedUser) {
                    console.info('Bulk Import controller: Subscribe On UserLogin Event: '
                        .concat(angular.toJson(authenticatedUser)));
                    $scope.bulkAttendanceAdjusterRole = authentication.hasBulkAttendanceAdjusterRole();
                    $scope.bulkEditAdditionRequirementRole = authentication.hasBulkEditAdditionRequirementRole();
                    $scope.bulkGradPlanImportRole = authentication.hasBulkGradPlanImportRole();
                    $scope.bulkSchoolDataRole = authentication.hasbulkSchoolDataRole();
                    $scope.bulkStudentCreateRole = authentication.hasbulkStudentCreateRole();
                    $scope.schoollist = authenticatedUser.schools;
                });

            if (authentication.isAuthenticated()) {
                // school list
                $scope.schoollist = authentication.getSchools();
                // bulk Attendance Adjuster role and Addition Requirement Role and gradplan Import Role
                $scope.bulkAttendanceAdjusterRole = authentication.hasBulkAttendanceAdjusterRole();
                $scope.bulkEditAdditionRequirementRole = authentication.hasBulkEditAdditionRequirementRole();
                $scope.bulkGradPlanImportRole = authentication.hasBulkGradPlanImportRole();
                $scope.bulkSchoolDataRole = authentication.hasbulkSchoolDataRole();
                $scope.bulkStudentCreateRole = authentication.hasbulkStudentCreateRole();
            }

            $scope.showAttAdjustment = false;
            $scope.showAdditionReq = false;
            $scope.completedUpload = false;
            $scope.closeSuccess = false;

            $scope.showContainer = function(){
            	$scope.reset();
            	if($scope.schoolId){

            		if($scope.bulkOption == 'attAdjustmentOption')
            		{
            			$scope.showAttAdjustment = true;
            			$scope.showAdditionReq = false;
                        $scope.showGradPlan = false;
                        $scope.showCourseCatalog = false;
                        $scope.showSchoolHolidayDetails = false;
                        $scope.showSchoolDatesDetails = false;
                        $scope.showStudentCreateDetails = false;
            		}
            		else if ($scope.bulkOption == 'addRequirementOption'){
            			$scope.showAdditionReq = true;
            			$scope.showAttAdjustment = false;
                        $scope.showGradPlan = false;
                        $scope.showCourseCatalog = false;
                        $scope.showSchoolHolidayDetails = false;
                        $scope.showSchoolDatesDetails = false;
                        $scope.showStudentCreateDetails = false;
            		}
                    else if ($scope.bulkOption == 'gradPlanOption'){
                        $scope.showGradPlan = true;
                        $scope.showAttAdjustment = false;
                        $scope.showAdditionReq = false;
                        $scope.showCourseCatalog = false;
                        $scope.showSchoolHolidayDetails = false;
                        $scope.showSchoolDatesDetails = false;
                        $scope.showStudentCreateDetails = false;
                    }
                    else if ($scope.bulkOption == 'courseCatalogOption'){
                        $scope.showCourseCatalog = true;
                        $scope.showGradPlan = false;
                        $scope.showAttAdjustment = false;
                        $scope.showAdditionReq = false;
                        $scope.showSchoolHolidayDetails = false;
                        $scope.showSchoolDatesDetails = false;
                        $scope.showStudentCreateDetails = false;
                    }
                    else if ($scope.bulkOption == 'schoolHolidayDetails'){
                        $scope.showCourseCatalog = false;
                        $scope.showGradPlan = false;
                        $scope.showAttAdjustment = false;
                        $scope.showAdditionReq = false;
                        $scope.showSchoolHolidayDetails = true;
                        $scope.showSchoolDatesDetails = false;
                        $scope.showStudentCreateDetails = false;
                    }
                    else if ($scope.bulkOption == 'schoolDatesDetails'){
                        $scope.showCourseCatalog = false;
                        $scope.showGradPlan = false;
                        $scope.showAttAdjustment = false;
                        $scope.showAdditionReq = false;
                        $scope.showSchoolHolidayDetails = false;
                        $scope.showSchoolDatesDetails = true;
                        $scope.showStudentCreateDetails = false;
                    }
                    else if ($scope.bulkOption == 'studentCreateDetails'){
                        $scope.showCourseCatalog = false;
                        $scope.showGradPlan = false;
                        $scope.showAttAdjustment = false;
                        $scope.showAdditionReq = false;
                        $scope.showSchoolHolidayDetails = false;
                        $scope.showSchoolDatesDetails = false;
                        $scope.showStudentCreateDetails = true;
                    }
            		else {
            			$scope.resetContainer();
            		}
            	}else{
            		$scope.resetContainer();
            	}
            };

            $scope.resetContainer = function(){
            	$scope.showAttAdjustment = false;
            	$scope.showAdditionReq = false;
                $scope.showGradPlan = false;
                $scope.showCourseCatalog = false;
                $scope.showSchoolHolidayDetails = false;
                $scope.showSchoolDatesDetails = false;
                $scope.showStudentCreateDetails = false;
            }

            $scope.downloadAttAdjustmentTmpl = function(){
            	bulkImportSvc.downloadTemplate($scope, schoolwork12.app.bulkImport.endpoints.bulkAttAdjustment);
            };

            $scope.downloadAddRequirementTmpl = function(){
            	bulkImportSvc.downloadTemplate($scope, schoolwork12.app.bulkImport.endpoints.bulkAddRequirement);
            };

            $scope.downloadGradPlanTmpl = function(){
                bulkImportSvc.downloadTemplate($scope, schoolwork12.app.bulkImport.endpoints.bulkGradPlan);
            };

            $scope.downloadCourseCatalogTmpl = function(){
                bulkImportSvc.downloadTemplate($scope, schoolwork12.app.bulkImport.endpoints.bulkCourseCatalog);
            };

            $scope.downloadSchoolHolidayTmpl = function(){
                bulkImportSvc.downloadTemplate($scope, schoolwork12.app.bulkImport.endpoints.bulkSchoolHoliday);
            };

            $scope.downloadSchoolDateTmpl = function(){
                bulkImportSvc.downloadTemplate($scope, schoolwork12.app.bulkImport.endpoints.bulkSchoolDate);
            };

            $scope.downloadStudentCreateTmpl = function(){
                bulkImportSvc.downloadTemplate($scope, schoolwork12.app.bulkImport.endpoints.bulkStudentCreate);
            };

            $scope.downloadAttAdjustmentErrorsTmpl = function(){
            	var bulkRequestId = $scope.bulkRequestId;
            	if(bulkRequestId){
            		bulkImportSvc.downloadErrorTemplate($scope, bulkRequestId, schoolwork12.app.bulkImport.endpoints.bulkAttAdjustment);
            	}else{
            		console.error('There is not a requestId to download errors template.');
            	}
            };

            $scope.downloadAddReqErrorsTmpl = function(){
            	var bulkRequestId = $scope.bulkRequestId;
            	if(bulkRequestId){
            		bulkImportSvc.downloadErrorTemplate($scope, bulkRequestId, schoolwork12.app.bulkImport.endpoints.bulkAddRequirement);
            	}else{
            		console.error('There is not a requestId to download errors template.');
            	}
            };

            $scope.downloadGradPlanErrorsTmpl = function(){
                var bulkRequestId = $scope.bulkRequestId;
                if(bulkRequestId){
                    bulkImportSvc.downloadErrorTemplate($scope, bulkRequestId, schoolwork12.app.bulkImport.endpoints.bulkGradPlan);
                }else{
                    console.error('There is not a requestId to download errors template.');
                }
            };

            $scope.downloadCourseCatalogErrorsTmpl = function(){
                var bulkRequestId = $scope.bulkRequestId;
                if(bulkRequestId){
                    bulkImportSvc.downloadErrorTemplate($scope, bulkRequestId, schoolwork12.app.bulkImport.endpoints.bulkCourseCatalog);
                }else{
                    console.error('There is not a requestId to download errors template.');
                }
            };

            $scope.downloadSchoolHolidaysErrorsTmpl = function(){
                var bulkRequestId = $scope.bulkRequestId;
                if(bulkRequestId){
                    bulkImportSvc.downloadErrorTemplate($scope, bulkRequestId, schoolwork12.app.bulkImport.endpoints.bulkSchoolHoliday);
                }else{
                    console.error('There is not a requestId to download errors template.');
                }
            };

            $scope.downloadSchoolDatesErrorsTmpl = function(){
                var bulkRequestId = $scope.bulkRequestId;
                if(bulkRequestId){
                    bulkImportSvc.downloadErrorTemplate($scope, bulkRequestId, schoolwork12.app.bulkImport.endpoints.bulkSchoolDate);
                }else{
                    console.error('There is not a requestId to download errors template.');
                }
            };

            $scope.downloadStudentErrorsTmpl = function(){
                var bulkRequestId = $scope.bulkRequestId;
                if(bulkRequestId){
                    bulkImportSvc.downloadErrorTemplate($scope, bulkRequestId, schoolwork12.app.bulkImport.endpoints.bulkStudentCreate);
                }else{
                    console.error('There is not a requestId to download errors template.');
                }
            };

            $scope.bulkImportFileSelected = function(){
            	if($scope.showAttAdjustment && !$scope.showAdditionReq && !$scope.showGradPlan && !$scope.showCourseCatalog && !$scope.showSchoolHolidayDetails && !$scope.showSchoolDatesDetails && !$scope.showStudentCreateDetails){
            		bulkImportSvc.uploadFileToUrl($scope, schoolwork12.app.bulkImport.endpoints.bulkAttAdjustment, 'attendance adjustment');
                	$scope.forms.formAttdAdj.$setDirty();
                }
            	if(!$scope.showAttAdjustment && $scope.showAdditionReq && !$scope.showGradPlan && !$scope.showCourseCatalog && !$scope.showSchoolHolidayDetails && !$scope.showSchoolDatesDetails && !$scope.showStudentCreateDetails){
            		bulkImportSvc.uploadFileToUrl($scope, schoolwork12.app.bulkImport.endpoints.bulkAddRequirement, 'additional requirements');
                    $scope.forms.formAddReq.$setDirty();
                }
                if($scope.showGradPlan && !$scope.showAttAdjustment && !$scope.showAdditionReq && !$scope.showCourseCatalog && !$scope.showSchoolHolidayDetails && !$scope.showSchoolDatesDetails && !$scope.showStudentCreateDetails){
                    bulkImportSvc.uploadFileToUrl($scope, schoolwork12.app.bulkImport.endpoints.bulkGradPlan, 'graduation plan');
                    $scope.forms.formGradPlan.$setDirty();
                }
                if($scope.showCourseCatalog && !$scope.showGradPlan && !$scope.showAttAdjustment && !$scope.showAdditionReq && !$scope.showSchoolHolidayDetails && !$scope.showSchoolDatesDetails && !$scope.showStudentCreateDetails){
                    bulkImportSvc.uploadFileToUrl($scope, schoolwork12.app.bulkImport.endpoints.bulkCourseCatalog, 'course catalog');
                    $scope.forms.formCourseCatalog.$setDirty();
                }
                if($scope.showSchoolHolidayDetails && !$scope.showCourseCatalog && !$scope.showGradPlan && !$scope.showAttAdjustment && !$scope.showAdditionReq && !$scope.showSchoolDatesDetails && !$scope.showStudentCreateDetails){
                    bulkImportSvc.uploadFileToUrl($scope, schoolwork12.app.bulkImport.endpoints.bulkSchoolHoliday, 'school holiday');
                    $scope.forms.formSchoolHoliday.$setDirty();
                }
                if($scope.showSchoolDatesDetails && !$scope.showCourseCatalog && !$scope.showGradPlan && !$scope.showAttAdjustment && !$scope.showAdditionReq && !$scope.showSchoolHolidayDetails && !$scope.showStudentCreateDetails){
                    bulkImportSvc.uploadFileToUrl($scope, schoolwork12.app.bulkImport.endpoints.bulkSchoolDate, 'school dates');
                    $scope.forms.formSchoolDates.$setDirty();
                }
                if($scope.showStudentCreateDetails && !$scope.showSchoolDatesDetails && !$scope.showCourseCatalog && !$scope.showGradPlan && !$scope.showAttAdjustment && !$scope.showAdditionReq && !$scope.showSchoolHolidayDetails){
                    bulkImportSvc.uploadFileToUrl($scope, schoolwork12.app.bulkImport.endpoints.bulkStudentCreate, 'students');
                    $scope.forms.formStudentCreate.$setDirty();
                }
            }

            $scope.closeSuccessMsg = function() {
            	$scope.closeSuccess = true;
            }

            $scope.importTemplate = function(){
            	var bulkRequestId = $scope.bulkRequestId;
            	if(bulkRequestId){
            		if($scope.showAttAdjustment == true ){
            			$scope.isImportBusy = true;
                		$http({
                            method:'PUT',
                            url: schoolwork12.app.bulkImport.endpoints.bulkAttAdjustment + "/" + bulkRequestId,
                            headers : {
                                'X-API-TOKEN' : authentication.getCurrentUser().keycode,
                            }
                       	})//.success(function (data, status, headers, config) {
                           .then(function(response) {
                       	    $scope.importSuccess = true;
                       	    $scope.importSuccessMsg = schoolwork12.app.bulkImport.successMessages.attAdjustmentImportSuccesMsg;
                       	    $scope.isImportBusy = false;
                       	    $scope.reset();
                       // }).error(function (error) {
                            }, function(error) {
                            console.info('Error importing bulk attendance adjustment template....'.concat(angular.toJson(error)));
                            $scope.submissionErrorOccurred = true;
                            $scope.isImportBusy = false;
                        	if (error.status == 400) {
            					for ( var j = 0; j < error.data._errors.length; j++) {
            						$scope.submissionErrorMesg = $scope.submissionErrorMesg + error.data._errors[j] + "\n";
            					}
            				} else if (error.status == 401 || error.status == 403) {
                                $scope.submissionErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.submissionErrorMesg = schoolwork12.app.errorMessages.internalError;
                            }
                       	});
                	} else if ($scope.showAdditionReq == true ){
                        $scope.isImportBusy = true;
                        $http({
                            method: 'PUT',
                            url: schoolwork12.app.bulkImport.endpoints.bulkAddRequirement + "/" + bulkRequestId,
                            headers : {
                                'X-API-TOKEN' : authentication.getCurrentUser().keycode,
                            }
                        })//.success(function (data, status, headers, config) {
                           .then(function(response) {
                            console.info("Import bulk additional requirement template");
                            $scope.importSuccess = true;
                            $scope.importSuccessMsg = schoolwork12.app.bulkImport.successMessages.addRequirementsImportSuccesMsg;
                            $scope.isImportBusy = false;
                            $scope.reset();
                       // }).error(function (error) {
                            }, function(error) {
                            console.info('Error importing bulk additional requirement template....'.concat(angular.toJson(error)));
                            $scope.submissionErrorOccurred = true;
                            $scope.isImportBusy = false;
                            if (error.status == 400) {
                                for ( var j = 0; j < error.data._errors.length; j++) {
                                    $scope.submissionErrorMesg = $scope.submissionErrorMesg + error.data._errors[j] + "\n";
                                }
                            } else if (error.status == 401 || error.status == 403) {
                                $scope.submissionErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.submissionErrorMesg = schoolwork12.app.errorMessages.internalError;
                            }
                        });
                    } else if ($scope.showGradPlan == true ){
                        $scope.isImportBusy = true;
                        $http({
                            method: 'PUT',
                            url: schoolwork12.app.bulkImport.endpoints.bulkGradPlan + "/" + bulkRequestId,
                            headers : {
                                'X-API-TOKEN' : authentication.getCurrentUser().keycode,
                            }
                        })//.success(function (data, status, headers, config) {
                           .then(function(response) {
                            console.info("Import bulk graduation plan template");
                            $scope.importSuccess = true;
                            $scope.importSuccessMsg = schoolwork12.app.bulkImport.successMessages.gradPlanImportSuccesMsg;
                            $scope.isImportBusy = false;
                            $scope.reset();
                       // }).error(function (error) {
                            }, function(error) {
                            console.info('Error importing bulk graduation plan template....'.concat(angular.toJson(error)));
                            $scope.submissionErrorOccurred = true;
                            $scope.isImportBusy = false;
                            if (error.status == 400) {
                                for ( var j = 0; j < error.data._errors.length; j++) {
                                    $scope.submissionErrorMesg = $scope.submissionErrorMesg + error.data._errors[j] + "\n";
                                }
                            } else if (error.status == 401 || error.status == 403) {
                                $scope.submissionErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.submissionErrorMesg = schoolwork12.app.errorMessages.internalError;
                            }
                        });
                    } else if ($scope.showCourseCatalog == true ){
                        $scope.isImportBusy = true;
                        $http({
                            method: 'PUT',
                            url: schoolwork12.app.bulkImport.endpoints.bulkCourseCatalog + "/" + bulkRequestId,
                            headers : {
                                'X-API-TOKEN' : authentication.getCurrentUser().keycode,
                            }
                        })//.success(function (data, status, headers, config) {
                            .then((response) => {
                                console.log('Response', response)
                                $scope.importSuccess = true;
                                $scope.importSuccessMsg = schoolwork12.app.bulkImport.successMessages.courseCatalogImportSuccesMsg;
                                $scope.isImportBusy = false;
                                $scope.reset();
                                // }).error(function (error) {
                            }, (error) => {
                                $scope.submissionErrorOccurred = true;
                                $scope.isImportBusy = false;
                                if (error.status == 400) {
                                    for ( var j = 0; j < error.data._errors.length; j++) {
                                        $scope.submissionErrorMesg = $scope.submissionErrorMesg + error.data._errors[j] + "\n";
                                    }
                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.submissionErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.submissionErrorMesg = schoolwork12.app.errorMessages.internalError;
                                }
                            });
                    } else if ($scope.showSchoolHolidayDetails == true ){
                        $scope.isImportBusy = true;
                        $http({
                            method: 'PUT',
                            url: schoolwork12.app.bulkImport.endpoints.bulkSchoolHoliday + "/" + bulkRequestId,
                            headers : {
                                'X-API-TOKEN' : authentication.getCurrentUser().keycode,
                            }
                        })
                            .then((response) => {
                                console.log('Response', response)
                                $scope.importSuccess = true;
                                $scope.importSuccessMsg = schoolwork12.app.bulkImport.successMessages.schoolHolidayImportSuccesMsg;
                                $scope.isImportBusy = false;
                                $scope.reset();
                            }, (error) => {
                                $scope.submissionErrorOccurred = true;
                                $scope.isImportBusy = false;
                                if (error.status == 400) {
                                    for ( var j = 0; j < error.data._errors.length; j++) {
                                        $scope.submissionErrorMesg = $scope.submissionErrorMesg + error.data._errors[j] + "\n";
                                    }
                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.submissionErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.submissionErrorMesg = schoolwork12.app.errorMessages.internalError;
                                }
                            });
                    } else if ($scope.showSchoolDatesDetails == true ){
                        $scope.isImportBusy = true;
                        $http({
                            method: 'PUT',
                            url: schoolwork12.app.bulkImport.endpoints.bulkSchoolDate + "/" + bulkRequestId,
                            headers : {
                                'X-API-TOKEN' : authentication.getCurrentUser().keycode,
                            }
                        })
                            .then((response) => {
                                console.log('Response', response)
                                $scope.importSuccess = true;
                                $scope.importSuccessMsg = schoolwork12.app.bulkImport.successMessages.schoolDatesImportSuccesMsg;
                                $scope.isImportBusy = false;
                                $scope.reset();
                            }, (error) => {
                                $scope.submissionErrorOccurred = true;
                                $scope.isImportBusy = false;
                                if (error.status == 400) {
                                    for ( var j = 0; j < error.data._errors.length; j++) {
                                        $scope.submissionErrorMesg = $scope.submissionErrorMesg + error.data._errors[j] + "\n";
                                    }
                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.submissionErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.submissionErrorMesg = schoolwork12.app.errorMessages.internalError;
                                }
                            });
                    } else if ($scope.showStudentCreateDetails == true ){
                        $scope.isImportBusy = true;
                        $http({
                            method: 'PUT',
                            url: schoolwork12.app.bulkImport.endpoints.bulkStudentCreate + "/" + bulkRequestId,
                            headers : {
                                'X-API-TOKEN' : authentication.getCurrentUser().keycode,
                            }
                        })
                            .then((response) => {
                                console.log('Response', response)
                                $scope.importSuccess = true;
                                $scope.importSuccessMsg = schoolwork12.app.bulkImport.successMessages.studentCreateImportSuccesMsg;
                                $scope.isImportBusy = false;
                                $scope.reset();
                            }, (error) => {
                                $scope.submissionErrorOccurred = true;
                                $scope.isImportBusy = false;
                                if (error.status == 400) {
                                    for ( var j = 0; j < error.data._errors.length; j++) {
                                        $scope.submissionErrorMesg = $scope.submissionErrorMesg + error.data._errors[j] + "\n";
                                    }
                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.submissionErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.submissionErrorMesg = schoolwork12.app.errorMessages.internalError;
                                }
                            });
                    }
                }
            	else{
            		console.error('There is not a requestId to import.');
            	}
            }

            $scope.reset = function(){
            	$scope.submissionErrorOccurred = false;
            	$scope.bulkImportAddReqFile = null;
            	$scope.bulkImportAttAdjFile=null;
                $scope.bulkImportGradPlanFile=null;
                $scope.bulkImportCourseCatalogFile=null;
                $scope.bulkImportSchoolHolidayFile=null;
                $scope.bulkImportSchoolDatesFile=null;
                $scope.bulkImportStudentCreateFile=null;
            	$scope.completedUpload = false;
            	$scope.failedPrevalidation = false;
            	$scope.closeSuccess = false;
            }

    }]);
}(angular, schoolwork12));

